var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarSpinWheel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_SpinWheel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 36",
    d: "M61 30.5C61 47.3447 47.3447 61 30.5 61C13.6553 61 0 47.3447 0 30.5C0 13.6553 13.6553 0 30.5 0C47.3447 0 61 13.6553 61 30.5ZM6.95736 30.5C6.95736 43.5022 17.4978 54.0426 30.5 54.0426C43.5022 54.0426 54.0426 43.5022 54.0426 30.5C54.0426 17.4978 43.5022 6.95736 30.5 6.95736C17.4978 6.95736 6.95736 17.4978 6.95736 30.5Z",
    fill: "#F998BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4988 2.46066C25.9354 -0.722143 34.3318 -0.820399 41.8409 2.18751L30.4996 30.5005L18.4988 2.46066ZM30.4996 30.5005L58.5394 18.4997C61.7222 25.9363 61.8204 34.3327 58.8125 41.8418L30.4996 30.5005ZM30.4996 30.5005L42.5003 58.5403C35.0637 61.7231 26.6673 61.8214 19.1582 58.8134L30.4996 30.5005ZM30.4996 30.5005L2.1866 19.1592C-0.821304 26.6682 -0.72305 35.0646 2.45975 42.5012L30.4996 30.5005Z",
    fill: "#F998BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarSpinWheel);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_SpinWheel.98a655e676e46e1542f6cbd5de026ee4.svg";
export { ForwardRef as ReactComponent };